export const CUSTOM_PRODUCT_PRIORITY = {
  learn: 1,
  elite: 2,
  live: 3,
  tickets: 4,
  nitro: 5,
};
